import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ENV } from '@app/constants/env';
import { getToken } from '@app/helpers/authProvider';
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';

export interface ShowWorefEntity {
  WORef1?: string;
  WORef2?: string;
  WORef3?: string;
  WORef4?: string;
  WORef5?: string;
  WORef6?: string;
  WORef7?: string;
  WORef8?: string;
  [key: string]: any;
}

const rawBaseQuery = fetchBaseQuery({
  baseUrl: ENV.BASE_API_URL +ENV.SHOW_APIURL,
});

const authBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  incomingArgs,
  api,
  extraOptions
) => {
  let args: string | FetchArgs = incomingArgs;
  if (typeof args === 'string') {
    args = { url: args };
  }
  try {
    const token = await getToken();
    if (token) {
      (args as FetchArgs).headers = {
        ...(args as FetchArgs).headers,
        Authorization: `Bearer ${token}`,
      };
    }
    return await rawBaseQuery(args, api, extraOptions);
  } catch {
    return { error: { status: 500, data: 'Token retrieval failed' } } as any;
  }
};

export const showWorefApi = createApi({
  reducerPath: 'showWorefApi',
  baseQuery: authBaseQuery,
  tagTypes: ['ShowWoref'],
  endpoints: (builder) => ({
    getShowWoref: builder.query<ShowWorefEntity, number>({
      query: (showId) => ({
        // Swagger shows route as /GetShowWoref/{id}
        url: `Shows/GetShowWoref/${showId}`,
        method: 'GET',
      }),
      providesTags: ['ShowWoref'],
    }),
  }),
});

export const { useGetShowWorefQuery } = showWorefApi;
